export * from './menu.selectors'



// WEBPACK FOOTER //
// ./src/app/shared/navbar/menu/store/selectors/index.ts